<ng-container>
  <div style="height: 100%">
    @if (lastTrapEvent()) {
      <div class="details">
        @if (lastTrapEvent().idSensor) {
          <vectronic-details-item header="Sensor ID">
            <ng-container>
              {{ lastTrapEvent().idSensor?.toString() }}
            </ng-container>
          </vectronic-details-item>
        }
        <vectronic-details-item header="Acquisition Time">
          <ng-container>
            {{ lastTrapEvent().scts | date: 'dd MMM yyyy HH:mm:ss' }}
          </ng-container>
        </vectronic-details-item>
        <vectronic-details-item header="Triggered">
          <ng-container>
            {{ lastTrapEvent().triggered ? 'Yes' : 'No' }}
          </ng-container>
        </vectronic-details-item>
        @if (lastTrapEvent().timeSinceTrigger) {
          <vectronic-details-item header="Time Since Trigger">
            <ng-container>
              {{ lastTrapEvent().timeSinceTrigger | date: 'dd MMM yyyy HH:mm:ss' }}
            </ng-container>
          </vectronic-details-item>
        }
        @if (lastTrapEvent().remainingLifetime) {
          <vectronic-details-item header="Remaining Lifetime">
            <ng-container>
              {{ convertSecondsToDateString(lastTrapEvent().remainingLifetime) }}
            </ng-container>
          </vectronic-details-item>
        }
      </div>
    } @else {
      <div class="details">
        <p class="trap-status__empty">There is no event for trap!</p>
      </div>
    }
    <div class="trap-details__footer"></div>
  </div>
</ng-container>
